
import type { SVGProps } from 'react';
const SvgOffer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#offer_svg__a)">
      <path
        fill="#263E6A"
        d="M13.106 14.07c0-1.222-.642-1.932-1.526-1.932-.883 0-1.526.71-1.526 1.932 0 1.226.643 1.95 1.526 1.95.884 0 1.526-.724 1.526-1.95m-1.526 1.182c-.31 0-.565-.314-.565-1.182s.255-1.162.565-1.162.565.294.565 1.162-.255 1.182-.565 1.182m4.51-.659c-.884 0-1.527.71-1.527 1.932 0 1.226.643 1.95 1.527 1.95s1.526-.725 1.526-1.95c0-1.223-.643-1.932-1.526-1.932m0 3.113c-.31 0-.565-.313-.565-1.181s.255-1.163.565-1.163.564.295.564 1.163-.255 1.181-.564 1.181m-.204-5.568-3.3 6.338h-.794l3.3-6.338zm4.258-2.84h-.979l-1.342-4.93a1.86 1.86 0 0 0-2.279-1.303L3.37 6.381c-.478.13-.877.439-1.123.87-.247.43-.31.93-.18 1.408l2.179 8.001a1.85 1.85 0 0 0 1.425 1.332v1.455c0 1.024.832 1.856 1.855 1.856h12.62A1.86 1.86 0 0 0 22 19.447v-8.292a1.86 1.86 0 0 0-1.856-1.856M4.888 16.486 2.71 8.484a1.18 1.18 0 0 1 .115-.903c.158-.276.414-.473.72-.557L15.72 3.709a1.19 1.19 0 0 1 1.46.834L18.474 9.3H7.525a1.86 1.86 0 0 0-1.855 1.856v6.147a1.18 1.18 0 0 1-.782-.817m16.445 2.962a1.19 1.19 0 0 1-1.189 1.19H7.525a1.19 1.19 0 0 1-1.189-1.19v-8.292c0-.656.534-1.19 1.19-1.19h12.618a1.19 1.19 0 0 1 1.19 1.19z"
      />
    </g>
    <defs>
      <clipPath id="offer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOffer;
